export default "__VITE_ASSET__$WL_pB____"